
      <!--  NAV LIST  -->

      <ul class="nav-list">

          <!--  MODULE LOOP  -->

          <li *ngFor="let module of modules">

              <!--  MODULE LINK  -->

              <a (click)="onClick(module)">

                  <!--  ICON  -->

                  <i *ngIf="!!module.icon" class="fa-fw fa-sm" [ngClass]="[module.icon, 'bg-' + module.theme]"></i>

                  <!--  END ICON  -->

                  <!--  MODULE NAME  -->

                  {{ module.name }}

                  <!--  END MODULE NAME  -->
              </a>

              <!--  END MODULE LINK  -->

          </li>

          <!--  END MODULE LOOP  -->

      </ul>

      <!--  END NAV LIST  -->
    